import { formatDateTimeJapanese } from "../../utils/datetime-utils";
import Icon from "../../components/icons/Icon.js";

function NotificationApprovalItem({ setOpenModal, supportValues }) {
  let background = "bg-[#FFFFFF]";
  let hover = "hover:bg-[#F9FAFB]";
  if (supportValues.status) {
    background = "bg-[#E9F7FD]";
    hover = "hover:bg-[#E9F7F4]";
  }
  return (
    <div
      className={`w-full border-t border-r border-gray-300 p-0 text-left ${background} ${hover}`}
    >
      <div className="p-2 border-l-2 h-[96px] border-[#7ed321]">
        <div className="flex h-[66px] p-2">
          <div className="flex-none w-7 flex items-center mr-4">
            <Icon name="sidebar-judgment" size={24} />
          </div>
          <div className="grow line-clamp-2">
            <p>
              <span className="align-super leading-[20px] break-all">
                未承認の点検があります。
              </span>
            </p>
            <div
              className="text-[16px] text-[#2374fd] hover:text-[#5898ff] w-fit cursor-pointer"
              onClick={() => setOpenModal(true)}
            >
              詳細...
            </div>
          </div>
        </div>
        <div className="text-right">
          <p className="text-sm">
            {formatDateTimeJapanese(supportValues.last_datetime)}
          </p>
        </div>
      </div>
    </div>
  );
}

export default NotificationApprovalItem;
